<h1>Welcome to SvelteKit</h1>
<p>Visit <a href="https://kit.svelte.dev">kit.svelte.dev</a> to read the documentation</p>

<h1 class="text-3xl font-bold underline">
	Hello world!
</h1>

<!--<style lang="postcss">-->
<!--    :global(html) {-->
<!--        background-color: theme(colors.blue.100);-->
<!--    }-->
<!--</style>-->